import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import Iconify from './Iconify';
import { PATH_DASHBOARD } from '../routes/paths';

export default function SubscriptionRequiredModal({ open }) {
  const navigate = useNavigate();

  const goToPlans = () => {
    navigate(PATH_DASHBOARD.subscription.create);
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      onClose={() => {}}
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'primary.lighter',
              color: 'primary.main',
            }}
          >
            <Iconify icon="mdi:crown-outline" width={28} height={28} />
          </Box>
          <Box>
            <Typography variant="h6">Subscription required</Typography>
            <Typography variant="body2" color="text.secondary">
              Your store is approved
            </Typography>
          </Box>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Before you can add products, choose an active subscription plan for your store.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Pick a package below to unlock product catalog, orders, and seller tools.
        </Typography>

        <Button
          fullWidth
          size="large"
          variant="contained"
          onClick={goToPlans}
          startIcon={<Iconify icon="eva:arrow-forward-fill" />}
        >
          Choose subscription plan
        </Button>
      </DialogContent>
    </Dialog>
  );
}

SubscriptionRequiredModal.propTypes = {
  open: PropTypes.bool.isRequired,
};
